import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { palette, theme as colorTheme } from "../../../../Convoze.theme";




function SearchBar({ value, onChange }) {


  const primary = colorTheme('palette', 'primary').value;

  return (
    <TextField
      fullWidth
      size="small"
      placeholder="Search users..."
      value={value}
      onChange={(e) => onChange(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ color: "text.secondary", fontSize: 20 }} />
          </InputAdornment>
        ),
      }}
      sx={{
        maxWidth: { xs: "100%", sm: 350, md: 732, lg: 760 },
        minWidth: { xs: "100%", sm: 200 },
        "& .MuiOutlinedInput-root": {
          "&:hover fieldset": { borderColor: primary},
          "&.Mui-focused fieldset": { borderColor: primary },
          "& .MuiInputBase-input": { fontSize: 14 },
        },
      }}
    />
  );
}

export default SearchBar;
